/**
 * Shared Product wrapper — GI Presenze
 *
 * Wrapper attorno al SuiteFooter Foundation/Core. Il componente CORE e' generico
 * (nessun riferimento a GI Presenze); questo wrapper inietta il contesto
 * specifico del Product Pack corrente:
 * - `productName = "Gestionale Presenze"` (Single Source of Truth Product Pack).
 *
 * Versione applicazione e data di rilascio arrivano dalla SSoT Foundation
 * (`GET /api/system/version`), non da questo wrapper.
 */
import React from "react";
import { SuiteFooter } from "@/foundation/shell";

const PRODUCT_NAME = "Gestionale Presenze";

export default function FooterPresenze() {
  return <SuiteFooter productName={PRODUCT_NAME} />;
}
